(function () {
  document.addEventListener(
    "click",
    async function (e) {
      const btn = e.target.closest("button[data-quick-add]");
      if (!btn) return;

      // Prevent theme/native handlers (drawer/modal)
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      const variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;

      const prevDisabled = btn.disabled;
      btn.disabled = true;

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "Accept": "application/json",
          },
          body: new URLSearchParams({ id: variantId, quantity: "1" }),
        });

        if (!res.ok) {
          console.error("Quick add failed", await res.text());
          return;
        }

        // Most drawer apps (including many UpCart setups) react automatically to /cart/add.js
        // If yours needs a nudge, we can add a specific UpCart open call once we find it.
        window.dispatchEvent(new CustomEvent("cart:updated", { detail: { source: "quick-add" } }));
      } catch (err) {
        console.error(err);
      } finally {
        btn.disabled = prevDisabled;
      }
    },
    true // capture phase (runs before theme)
  );
})();